import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Auth/Login';
import LoginPage from './pages/LoginPage';
import Register from './components/Auth/Register';
import RegisterPage from './components/Auth/RegisterPage';
import OtpVerification from './components/Auth/OtpVerification';
import Dashboard from './pages/Dashboard';
import Profile from './pages/users/Profile';
import Home from './pages/Home';
import Search from './pages/users/Search';
import ViewBeforePurchase from './pages/ViewBeforePurchase';
// import ViewAfterPurchase from './pages/ViewAfterPurchase';
import Recommended from './pages/Recommended';
import Purchase from './pages/Purchase';
import AboutUs from './info/AboutUs';
import PrivacyPolicy from './info/PrivacyPolicy';
import ShippingDelivery from './info/ShippingDelivery';
import CancellationRefund from './info/CancellationRefund';
import ContactUs from './info/ContactUs';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import ScrollToTop from './components/ScrollToTop';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import TermsAndConditions from './info/TermsAndConditions';
import GustUser from './pages/users/GustUser';
import PaymentSuccess from './pyment/PaymentSuccess';
import Unsubscribe from './info/Unsubscribe';
import GuestUserDashboard from './pages/gust/GuestUserDashboard';
// import GuestHome from './pages/gust/GuestHome';
import DemoDashboard from './pages/gust/DemoDashboard';
import ResetPassword from './components/Auth/ResetPassword';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AuthProvider>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/login-page" element={<LoginPage />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register-page" element={<RegisterPage />} />
            <Route path="/verify-otp" element={<OtpVerification />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/shipping-delivery" element={<ShippingDelivery />} />
            <Route path="/cancellation-refund" element={<CancellationRefund />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/guest-register" element={<GustUser />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/reset-password/:email/:type/:time" element={<ResetPassword />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/guest-search"
              element={<Search />}
            />
            <Route
              path="/view-before-purchase"
              element={<ViewBeforePurchase />}
            />
            {/* <Route
              path="/view-after-purchase"
              element={
                <ProtectedRoute>
                  <ViewAfterPurchase />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="/recommended"
              element={
                <ProtectedRoute>
                  <Recommended />
                </ProtectedRoute>
              }
            />
            <Route
              path="/purchase"
              element={
                // <ProtectedRoute>
                  <Purchase />
                // </ProtectedRoute>
              }
            />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/unregister" element={<Unsubscribe />} />
            <Route path="/guestDashboard" element={<GuestUserDashboard />} />
            {/* <Route path="/guestHome" element={<GuestHome />} /> */}
            <Route path="/demo-dashboard" element={<DemoDashboard />} />
          </Routes>
          <Footer />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;